module.exports = __webpack_public_path__ + "img/umraniye-logo.8afa6cf3.png";